module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pa-0": "",
      "mt-5": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "sm6": "",
      "mt-5": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('div', {
    staticClass: "error-text primary--text text-xs-center"
  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
    staticClass: "font-20 text-xs-center mt-4"
  }, [_vm._v(_vm._s(_vm.$t("page500.serverError")))]), _vm._v(" "), _c('div', {
    staticClass: "font-18 text-xs-center mt-4 mb-4"
  }, [_vm._v(_vm._s(_vm.$t("page500.hintMessage")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "flat": "",
      "outline": "",
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("page500.homepageButton")))])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5832fb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/Page500.vue
// module id = 467
// module chunks = 0